module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/exclusivenessIcon.f3514995.svg";